module.exports = __webpack_public_path__ + "static/img/pic-7.1479f02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/pic-7.jpg
// module id = cYKz
// module chunks = 1